// Submit note form on blur in shipments#index
$('.item_note_form').on('blur', "input[name='shipment[notes]']", function () {
  const $form = $(this).parent()
  Rails.fire($form[0], 'submit')
})
